import { Routes } from '@angular/router';
import { FindGamesHomeComponent, GamesListComponent, LocationDetailsComponent, MapComponent } from './components';
import { blockWebVersionGuard, FindGamesRoutes } from '@core';
import { isAuthedGuard } from '@auth';

export const FindGamesRouting: Routes = [
  {
    path: '',
    component: FindGamesHomeComponent,
    children: [
      {
        path: '',
        component: GamesListComponent,
        canActivate: [isAuthedGuard, blockWebVersionGuard]
      },
      {
        path: FindGamesRoutes.MAP,
        component: MapComponent
      }
    ]
  },
  {
    path: `${FindGamesRoutes.LOCATION}/:id`,
    component: LocationDetailsComponent,
    canActivate: [blockWebVersionGuard, isAuthedGuard]
  }
];
